/** To be kept in sync with class NumberParsingFormat in benchling/lib/core/numbers.py
 * See benchling/lib/core/numbers.py for more information on NumberParsingFormat
 */
export interface NumberParsingFormat {
  groupDelimiter: string;
  decimalDelimiter: string;
  /** Unicode CLDR based pattern that determines how numbers should be placed around group delimiters (ex. "#,##0.###" corresponds to 1,234,567.89). */
  numberPattern: string;
}

// Number parsing format for en-US locale
export const DEFAULT_NUMBER_PARSING_FORMAT = {
  decimalDelimiter: '.',
  groupDelimiter: ',',
  numberPattern: '#,##0.###',
};

export const GROUP_DELIMITERS_TO_SUPPORTED_ALTERNATIVES: {[key: string]: string} = {
  '\xa0': ' ',
  '\u202f': ' ',
  '’': "'",
};
